/* eslint-disable max-classes-per-file */
import _, { assign } from "lodash";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { VKSnabbkalkylmallDTO } from "./snabbkalkylmall-models";
import { VKForkalkylTradslagDTO, VKProduktGruppDTO } from "./tradslag-models";

export interface DirektutbyteBerakningRequest {
    atgardguid?: string;
    atgardbeteckning: string;
    geometri: string;
    atgardAvverkningsTyp: string;
    nettoareal?: number;
    tradslag: VKDirektutbyteTradslagDTO[];
}

export interface DirektutbyteBerakningResponseDTO {
    beraknadTid?: Date;
    utbyte?: VKDirektutbyteUtbyteDTO;
    beraknadMedelstam?: number;
    beraknatStamantal?: number;
    direktutbyteStatus: string;
    direktutbyteText: string;
}

export class VKDirektutbyteTradslagDTO {
    m3skHa?: number;
    grundyta?: number;
    diameterGrundytevagd?: number;
    hojdGrundyteVagd?: number;
    stammarperHa?: number;
    medelstam?: number;
    tradslag: VKForkalkylTradslagDTO;
}

export const allTradslagHasValues = (direktutbyteTradslag?: VKDirektutbyteTradslagDTO[]) => {
    const emptyTradslag = direktutbyteTradslag?.some(x =>
        !x.m3skHa ||
        !x.grundyta ||
        !x.diameterGrundytevagd ||
        !x.hojdGrundyteVagd ||
        !x.stammarperHa ||
        !x.medelstam);

    return !emptyTradslag;
};

export class VKDirektutbyteProduktgruppDTO {
    id?: number;
    kvantitetHa?: number;
    produktgrupp: VKProduktGruppDTO;
}

export class VKDirektutbyteUtbyteDTO {
    summa: number;
    timmerandel: number;
    produktgrupper: VKDirektutbyteProduktgruppDTO[];
}

export class VKDirektutbyteDTO {
    id?: number;
    beraknadTid?: Date;
    arborealBeraknadTid?: Date;
    direktutbyteTradslag?: VKDirektutbyteTradslagDTO[];
    utbyte?: VKDirektutbyteUtbyteDTO;
    beraknadMedelstam?: number;
    beraknatStamantal?: number;
    direktutbyteStatus: string;
    direktutbyteText: string;
    importKalla: string;
}

export class VKDirektutbyteArborealDTO {
    arborealBeraknadTid: Date;
    direktutbyteTradslag: VKDirektutbyteTradslagDTO[];
    messageLevel: number;
    errorMessage: string;
}

export class VKDirektutbyte extends VKDirektutbyteDTO {
    direktutbyteTradslag: VKDirektutbyteTradslagDTO[] = [];

    constructor(dto?: VKDirektutbyteDTO) {
        super();
        if(dto) {
            assign(this, dto);
        }
    }

    get medelstam() {
        if(ObjectUtils.isNullOrUndefined(this.beraknadMedelstam)) {
            return null;
        }

        return _.round(this.beraknadMedelstam, 2);
    }

    toMallDto(mallNamn: string) {
        const snabbkalkylmall: VKSnabbkalkylmallDTO = new VKSnabbkalkylmallDTO();
        snabbkalkylmall.namn = mallNamn;
        snabbkalkylmall.kalkylmallTradslag = [];

        this.direktutbyteTradslag?.forEach((direktutbyteTradslag: VKDirektutbyteTradslagDTO, i) => {
            const tradslag: VKForkalkylTradslagDTO = direktutbyteTradslag.tradslag;

            snabbkalkylmall.kalkylmallTradslag.push({
                andel: null,
                medelstam: null,
                timmerandel: null,
                massavedandel: null,
                branslevedandel: null,
                varavGrovtimmer: null,
                varavKlentimmer: null,
                tradslag
            });

        });
        return snabbkalkylmall;
    }
}
